import { Component } from '@angular/core';
import { GcLoadingSpinnerComponent } from '@ip-only/front-end-library';

@Component({
  selector: 'app-loading-self-inspection',
  imports: [GcLoadingSpinnerComponent],
  templateUrl: './loading-self-inspection.component.html',
  styleUrl: './loading-self-inspection.component.scss',
})
export class LoadingSelfInspectionComponent {}
